<template>
  <div class="p-4 w-full">
    <section class="space-y-8">
      <header class="space-y-2">
        <BaseButton small primary outline @click="$emit('back')">Back</BaseButton>
        <h3 class="text-lg font-medium">Membership products</h3>
      </header>
      <BaseDataIterator :service="fetchData" nested flat>
        <!-- props
          data, fetchList
        -->
        <template #default="dataIteratorProps">
          <BaseDataTable :data="dataIteratorProps.data">
            <template #default="{ item }">
              <tr :key="item.uuid" class="odd:bg-gray-50">
                <td class="p-4 text-sm font-medium text-gray-900">
                  {{ item.name }}
                </td>
                <td class="whitespace-nowrap p-4 text-gray-900 w-0">
                  <BaseButton primary small outline @click="$emit('select', item.uuid)"
                    >Select</BaseButton
                  >
                </td>
              </tr>
            </template>
          </BaseDataTable>
        </template>
      </BaseDataIterator>
    </section>
  </div>
</template>

<script>
import { merge } from 'lodash-es';
import { accountProjectsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    customerAccountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fetchData(params = {}) {
      return accountProjectsClient.list(
        this.accountId,
        merge(JSON.parse(JSON.stringify(params)), {
          filter: {
            client_id__is: this.customerAccountId,
          },
        })
      );
    },
    handleSelectProject(projectId) {
      this.$emit('select', projectId);
    },
  },
};
</script>
